import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/subTarea/importer/subTareaImporterActions';

export default importerReducers(actions);
